module.exports = __webpack_public_path__ + "img/CheckCircle-Icon.7d534941.svg";